"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompanyFiscalYear = void 0;
const moment_1 = __importDefault(require("moment"));
const getCompanyFiscalYear = (fiscalYearStart) => {
    const { day: dayOfMonth, month } = fiscalYearStart;
    const today = (0, moment_1.default)().utc();
    const currentYear = today.get("year");
    const fiscalYearStartMoment = (0, moment_1.default)().utc().set({ year: currentYear, month, date: dayOfMonth });
    const newFiscalYearStart = today.isSameOrAfter(fiscalYearStartMoment)
        ? (0, moment_1.default)().utc().startOf("year").date(dayOfMonth).month(month)
        : (0, moment_1.default)().utc().subtract(1, "year").startOf("year").date(dayOfMonth).month(month);
    const newFiscalYearEnd = (0, moment_1.default)(newFiscalYearStart).utc().add(1, "year").subtract(1, "days").endOf("day");
    return {
        start: newFiscalYearStart,
        end: newFiscalYearEnd,
    };
};
exports.getCompanyFiscalYear = getCompanyFiscalYear;
